import React from 'react'

import { Box } from '@mui/material'

import { SocialProofItemProps } from '../SocialProofBanner.types'
import styles from './SocialProofItem.styles'

const SocialProofItem: React.FC<SocialProofItemProps> = ({ item }) => {
  return (
    <Box sx={styles.socialProofItem} tabIndex={0}>
      <Box component="img" src={item.imageUrl} alt={item.altText} loading="lazy" sx={styles.socialProofImage} />
    </Box>
  )
}

export default SocialProofItem
